import { render, staticRenderFns } from "./PublicDele.vue?vue&type=template&id=6c9d2cd0&scoped=true&"
import script from "./PublicDele.vue?vue&type=script&lang=js&"
export * from "./PublicDele.vue?vue&type=script&lang=js&"
import style0 from "./PublicDele.vue?vue&type=style&index=0&id=6c9d2cd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9d2cd0",
  null
  
)

export default component.exports